"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import { ServicesPricingPlansProps } from "./types";
import ServicePlanCard from "../ServicePlanCard";

const ServicesPricingPlans = ({ className, cardClassName, cards }: ServicesPricingPlansProps) => {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3",
        className
      )}
    >
      {cards?.map((card, idx) => {
        return (
          <ServicePlanCard
            key={idx}
            title={card.title}
            image={card.image}
            price={card.price}
            description={card.description}
            mainButton={card?.mainButton}
            mainButtonLink={card?.mainButtonLink}
            secondaryButton={card?.secondaryButton}
            secondaryButtonLink={card?.secondaryButtonLink}
            highlight={card?.highlight}
            className={cn("lg:h-[564] sm:not-even:last:col-span-2 lg:not-even:last:col-span-1", cardClassName)}
          />
        );
      })}
    </div>
  );
};

export default memo(ServicesPricingPlans);
